define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  "use strict";

  const cloudModel = {};

  cloudModel.exportDocument = Backbone.Model.extend({
    initializeCustom: function (options) {
      this.intentId = options.intentId;
      this.responseId = options.responseId;
      this.documentId = options.documentId;
      this.set("id", options.documentId);
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/${this.intentId}/responses/${this.responseId}/templates/${this.documentId}/ckEditorCloud/export`;
    },
  });

  cloudModel.importDocument = Backbone.Model.extend({
    initializeCustom: function (options) {
      this.intentId = options.intentId;
      this.responseId = options.responseId;
      this.documentId = options.documentId;
      this.set("id", options.documentId);
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/${this.intentId}/responses/${this.responseId}/templates/${this.documentId}/ckEditorCloud/import`;
    },
  });

  cloudModel.removeDocument = Backbone.Model.extend({
    initializeCustom: function (options) {
      this.intentId = options.intentId;
      this.responseId = options.responseId;
      this.documentId = options.documentId;
      this.set("id", options.documentId);
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/${this.intentId}/responses/${this.responseId}/templates/${this.documentId}/ckEditorCloud/remove`;
    },
  });

  cloudModel.connectedUsers = Backbone.Model.extend({
    defaults: {
      connectedUsers: [],
    },
    initializeCustom: function (options) {
      this.intentId = options.intentId;
      this.responseId = options.responseId;
      this.documentId = options.documentId;
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/${this.intentId}/responses/${this.responseId}/templates/${this.documentId}/ckEditorCloud/connectedUsers`;
    },
  });

  return cloudModel;
});
